import { useQuery } from "@tanstack/react-query";

import { getFarmDocScanFields } from "services";

import { GET_FARM_DOC_SCAN_FIELDS } from "consts";

import { DocScanFieldResult, GetFarmDocScanFieldsResponse } from "models";

export const getDocScanFieldResultKey = (fieldId: string, year: number) => `${fieldId}:${year}`;

const toResultsByFieldAndYear = ({ fields }: GetFarmDocScanFieldsResponse) =>
  new Map<string, DocScanFieldResult>(fields.map((result) => [getDocScanFieldResultKey(result.fieldId, result.year), result]));

export const useGetFarmDocScanFields = ({ farmId }: { farmId: string }) =>
  useQuery({
    queryKey: [GET_FARM_DOC_SCAN_FIELDS, farmId],
    queryFn: async (): Promise<GetFarmDocScanFieldsResponse> => getFarmDocScanFields({ farmId }),
    select: toResultsByFieldAndYear,
    enabled: !!farmId,
    staleTime: 1000 * 60 * 5,
  });
